const prefix = "SYSTEM_LOG_";

export const EXPORT_FAILED = prefix + "EXPORT_FAILED";
export const EXPORT_STARTED = prefix + "EXPORT_STARTED";
export const EXPORT_SUCCEEDED = prefix + "EXPORT_SUCCEEDED";
export const LIST_CLEAR_CRITERIA = prefix + "LIST_CLEAR_CRITERIA";
export const LIST_FAILED = prefix + "LIST_FAILED";
export const LIST_KEEP_CRITERIA = prefix + "LIST_KEEP_CRITERIA";
export const LIST_SET_CRITERIA = prefix + "LIST_SET_CRITERIA";
export const LIST_SET_CRITERIA_DESCRIPTION = prefix + "LIST_SET_CRITERIA_DESCRIPTION";
export const LIST_SET_FILTERS = prefix + "LIST_SET_FILTERS";
export const LIST_SET_PAGING = prefix + "LIST_SET_PAGING";
export const LIST_STARTED = prefix + "LIST_STARTED";
export const LIST_SUCCEEDED = prefix + "LIST_SUCCEEDED";
export const LIST_TOGGLE_EXPAND = prefix + "LIST_TOGGLE_EXPAND";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
